var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('LoginBox',{attrs:{"authMode":"staff","staffData":_vm.staffData,"errorMsg":_vm.errorMsg,"hasBorder":"true"},on:{"onStaffSelected":_vm.selectStaff,"onSubmit":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }